"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = exports.DirectInsertBorrowingBaseReportConfigSchema = void 0;
const v4_1 = require("zod/v4");
// every node must export UIConfig.
// this type describes the configuration
// for the node as seen on tape-builder UI.
// there must also be a json schema associated with it.
exports.DirectInsertBorrowingBaseReportConfigSchema = v4_1.z.object({
    borrowingBaseReportLpSlugArtifactSlug: v4_1.z
        .string()
        .describe('Artifact slug of borrowing base report metrics for each loan product slug. CSV with column headers: "loanProductSlug", "totalReceivableExposure", "assetValuation", "totalEligibleExposure", "totalEligibilityKickout", "eligibleExposureLessConcentrationKickouts", "totalConcentrationKickout", "borrowingBaseAmount", "performingExposure"'),
    eligibilityTestArtifactSlug: v4_1.z
        .string()
        .optional()
        .describe('Artifact slug of eligibility tests. CSV with column headers: "eligibilityCriteriaKey", "eligibilityReduction"'),
    concentrationLimitKickoutArtifactSlug: v4_1.z
        .string()
        .optional()
        .describe('Artifact slug of concentration limit tests. CSV with column headers: "concentrationLimitKey", "concentrationLimit", "concentrationAmount", "totalEligibleExposure", "concentration", borrowingBaseReduction'),
    multiLoanProductConcentrationKickoutLpSlugArtifactSlug: v4_1.z
        .string()
        .optional()
        .describe('Artifact slug of multi concentration limit tests. CSV with column headers: "concentrationLimitKey", "borrowingBaseReduction", "loanProductSlug"'),
    classDetailsArtifactSlug: v4_1.z
        .string()
        .optional()
        .describe('Artifact slug of class details. CSV with column optional headers of "a", "a1", "a2", "b", "b1", etc... and single row of values corresponding attachment rate limit'),
    fundingSubmissionComponentsArtifactSlug: v4_1.z
        .string()
        .optional()
        .describe('Artifact slug of funding request submissions. CSV with 3 columns: "type" (i.e. funding request component type), "totalAmount", "targetFundingDate"'),
});
exports.UIConfigSchema = v4_1.z
    .object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    creditFacilitySlug: v4_1.z.string().describe('Credit facility slug'),
})
    .merge(exports.DirectInsertBorrowingBaseReportConfigSchema);
exports.nodeType = 'file_directInsertBorrowingBaseReport';
// every tape node must also export IntermediateRecordConfig.
// this type describes the configuration for the IntermediateRecord
// (type generated by converting UI Tape + Operation Node config ).
// this includes the config for the preceding operation + config for the Tape
// + any synthetic/generated config that is needed for the corresponding task.
// - any fields that are not part of config but are part of top level record.
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
    creditFacilitySlug: true,
}).extend({
    generatedCashBalanceFeedArtifactSlug: v4_1.z
        .string()
        .nullable()
        .describe('If "Direct Insert BBR" requires "generated cash balance feed", can determine from the graph based on connections and set this so subsequent synthetic processing can utilize'),
});
// every tape node must also export IntermediateRecord.
// it describes the record that will be inserted into the database. (well not completely,
// because it may be modified by synthetic node creation later)
// it includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
exports.artifactType = 'directInsertBorrowingBaseReport';
//# sourceMappingURL=types.js.map